const STORAGE_KEY = "@cecis:projectNames";

// A URL só carrega projectId e nenhuma rota HTTP expõe GET /projects/:id, então
// o nome do projeto vem do clique na linha. Este cache é o que faz o breadcrumb
// sobreviver a um F5 em URL profunda — e degrada em silêncio se o
// sessionStorage não estiver disponível.
function readAll() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

export function remember(projectId, projectName) {
  if (!projectId || !projectName) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readAll(), [projectId]: projectName }));
  } catch {
    /* cota estourada ou storage bloqueado: o breadcrumb cai no placeholder. */
  }
}

export function read(projectId) {
  return readAll()[projectId] || null;
}

// Cascata da §7.2: o clique na linha de Projetos é o caminho normal, o
// payload de /sprints cobre o F5, o cache cobre a URL profunda aberta em
// outra sessão de navegação, e o placeholder nunca deixa a trilha em branco.
export function resolveProjectName(projectId, locationState, sprints) {
  return (
    locationState?.projectName ||
    sprints?.[0]?.project?.name ||
    read(projectId) ||
    `Projeto #${projectId}`
  );
}
